module.exports = __webpack_public_path__ + "static/media/CDKGlobalWM_BLK.12a509b0.jpg";